import { useOnlineStatus } from '@gripp/shared-logic';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from 'react-native';
import { themedStyleSheet } from '../../themes/themedStyleSheet';
import { spacing, typography } from '../crop-circle/tokens';

/** Explains why an action is disabled offline; renders nothing while online. */
export const OfflineSubmitNotice: React.FC<{ message?: string }> = ({
  message,
}) => {
  const { isOnline } = useOnlineStatus();
  const { t } = useTranslation();
  if (isOnline) return null;
  return (
    <Text style={styles.message} testID="offline-submit-notice">
      {message ?? t('offline.submitDisabled')}
    </Text>
  );
};

const styles = themedStyleSheet((role) => ({
  message: {
    ...typography.label.medium,
    color: role.textDisabled,
    textAlign: 'center',
    paddingVertical: spacing.sm,
  },
}));
